import { action, computed, thunk } from "easy-peasy";
import moment from "moment";
import { RULES } from "Constants/rules";
import { CONDITION_TIME_RATIO } from "Constants/contract";
import { date } from "yup";

export const ContractFormStoreModel = {
  conditions: [],
  cashFlowOW: computed((state) => {
    let cashflow = [];
    if (!state.conditions) return [];
    if (state.conditions.length <= 0) return [];

    state.conditions.forEach((condition, index) => {
      let frequencyUnit = "";
      switch (condition.frequencyUnit.id) {
        case 1:
          frequencyUnit = "months";
          break;
        case 2:
          frequencyUnit = "years";
          break;
      }

      let diff = moment(condition.dateOfFinish || moment())
        .startOf("day")
        .diff(
          moment(condition.dateOfBeginning).startOf("day"),
          frequencyUnit,
          true
        );

      let documentAmount =
        condition.type?.debitCredit === "DEBIT"
          ? condition.documentAmount
          : condition.documentAmount * -1;

      if (condition.purpose.rule?.code == RULES.RULE0007) {
        cashflow.push({
          purpose: condition.purpose,
          type: condition.type,
          documentAmount: documentAmount,
          documentCurrency: condition.documentCurrency,
          dateOfBeginning: moment(condition.dateOfBeginning),
          dateOfFinish: moment(condition.dateOfBeginning),
          dateOfMaturity: moment(condition.dateOfBeginning).add(
            condition.maturityVal || 0,
            "d"
          ),
        });
      } else {
        diff = Math.ceil(diff / condition.frequencyVal);
        if (diff <= 0) diff = 1;

        let dateOfBeginning = moment(condition.dateOfBeginning).startOf("d");

        for (let i = 1; i <= diff; i++) {
          let itemAmount = documentAmount;
          let dateOfFinish = moment(dateOfBeginning);

          if (
            condition.timeRatio ===
            CONDITION_TIME_RATIO["Asla zaman orantılı değil"]
          ) {
            dateOfFinish = moment(dateOfFinish)
              .add(condition.frequencyVal, frequencyUnit)
              .subtract(1, "d");
          } else {
            dateOfFinish = moment(dateOfFinish)
              .add(condition.frequencyVal - 1, frequencyUnit)
              .endOf(frequencyUnit);

            let diffDays = moment(dateOfFinish)
              .add(1, "d")
              .diff(moment(dateOfBeginning).startOf("d"), "days");

            let realDiff = moment(dateOfFinish)
              .endOf(frequencyUnit)
              .add(1, "d")
              .diff(
                moment(dateOfBeginning).startOf(frequencyUnit).startOf("d"),
                "days"
              );

            if (
              i == diff &&
              moment(condition.dateOfFinish).isAfter(moment(dateOfFinish))
            )
              diff++;

            //Nakit akışının ilk kalemi ve Başlangıç tarihine göre zaman orantısı var ise
            if (
              i == 1 &&
              [
                CONDITION_TIME_RATIO["Sözleşme başlangıcı ve bitişi"],
                CONDITION_TIME_RATIO["Yalnızca sözleşme başlangıcı"],
              ].includes(condition.timeRatio)
            ) {
              itemAmount = (itemAmount / realDiff) * diffDays;
            }

            //Nakit akışının son kalemi ve Bitiş tarihine göre zaman orantısı var ise
            if (i == diff) {
              dateOfFinish = moment(condition.dateOfFinish).endOf("d");
              if (
                [
                  CONDITION_TIME_RATIO["Sözleşme başlangıcı ve bitişi"],
                  CONDITION_TIME_RATIO["Yalnızca sözleşme bitişi"],
                ].includes(condition.timeRatio)
              ) {
                diffDays = moment(dateOfFinish)
                  .add(1, "d")
                  .diff(moment(dateOfBeginning), "days");

                itemAmount = (itemAmount / realDiff) * diffDays;
              }
            }
          }

          cashflow.push({
            purpose: condition.purpose,
            type: condition.type,
            documentAmount: itemAmount,
            documentCurrency: condition.documentCurrency,
            dateOfBeginning: moment(dateOfBeginning),
            dateOfFinish: moment(dateOfFinish),
            dateOfMaturity: moment(dateOfBeginning).add(
              condition.maturityVal || 0,
              "d"
            ),
          });

          dateOfBeginning = dateOfFinish.add(1, "d");
        }
      }
    });

    return cashflow.sort((previous, current) => {
      if (previous.dateOfMaturity.isBefore(current.dateOfMaturity)) {
        return -1;
      }

      if (previous.dateOfMaturity.isSame(current.dateOfMaturity)) {
        return 0;
      }

      return 1;
    });
  }),

  setConditions: action((state, payload) => {
    state.conditions = payload;
  }),

  appendCondition: action((state, payload) => {
    state.conditions = [payload, ...state.conditions];
  }),

  updateCondition: action((state, payload) => {
    let oldConditions = [...state.conditions];
    oldConditions[payload.index] = {
      ...oldConditions[payload.index],
      ...payload.item,
    };
    state.conditions = oldConditions;
  }),

  removeCondition: action((state, payload) => {
    state.conditions.splice(payload, 1);
  }),
};
